import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import PrismIcon from './icon.gts';

interface PrismCheckboxSignature {
  Args: {
    checked?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    isSecondary?: boolean;
    isSmall?: boolean;
    onChange?: (event: Event) => void;
    value?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLInputElement;
}

export default class PrismCheckbox extends Component<PrismCheckboxSignature> {
  get checkboxIconName(): 'checkmark' | 'minus' | undefined {
    const { checked, indeterminate } = this.args;

    if (checked) {
      return 'checkmark';
    }

    if (indeterminate) {
      return 'minus';
    }

    return undefined;
  }

  @action handleChange(event: Event): void {
    this.args.onChange?.(event);
  }

  <template>
    <label
      class={{concat
        "prism-checkbox"
        " "
        (if @isSmall "text-200--regular" "text-300--regular")
        " "
        (if @isSecondary "prism-checkbox--secondary")
        " "
        (if @disabled "prism-checkbox--disabled")
      }}
    >
      <input
        checked={{@checked}}
        data-test-indeterminate={{@indeterminate}}
        disabled={{@disabled}}
        indeterminate={{@indeterminate}}
        type="checkbox"
        value={{@value}}
        {{on "change" this.handleChange}}
        ...attributes
      />

      <span
        class={{concat
          "prism-checkbox__checkmark"
          " "
          (if @isSmall "prism-checkbox__checkmark--small")
        }}
      >
        {{#if this.checkboxIconName}}
          <PrismIcon
            @color={{if @disabled "disabled" "default-inverse"}}
            @name={{this.checkboxIconName}}
            @size="small"
          />
        {{/if}}
      </span>

      {{#if (has-block)}}
        <div
          class={{concat
            "prism-checkbox__label"
            " "
            (if @disabled "prism-checkbox__label--disabled")
          }}
        >
          {{yield}}
        </div>
      {{/if}}
    </label>
  </template>
}
